module.exports = __webpack_public_path__ + "media/components/country-flag/static/eg-fe4093b113560124b08af6f703713168.svg";